export const getProductsInit = 'GET_PRODUCTS_INIT'
export const getProductsSuccess = 'GET_PRODUCTS_SUCCESS'
export const getProductsError = 'GET_PRODUCTS_ERROR'
